module.exports = __webpack_public_path__ + "b162d12164e22725d86b5c2302258f2a.jpg";